import { Button, Text } from "react-native-paper";
import { useAppTheme } from "../../../../useAppTheme";
import { AppIcon } from "../../../AppIcon";
import Box from "../../../Box";

export type MicCheckState = "idle" | "recording" | "success";

type Props = {
	state: MicCheckState;
	successMessage: string;
	isPlaying?: boolean;
	onRecord?: () => void;
	onStop?: () => void;
	onPlayback?: () => void;
	onRecordAgain?: () => void;
};

export const MicCheckControls = ({
	state,
	successMessage,
	isPlaying,
	onRecord,
	onStop,
	onPlayback,
	onRecordAgain,
}: Props) => {
	const theme = useAppTheme();

	const primaryButton =
		state === "recording" ? (
			<Button
				mode="contained"
				icon="stop"
				buttonColor={theme.colors.errorContainer}
				textColor={theme.colors.onErrorContainer}
				onPress={onStop}
			>
				Stop
			</Button>
		) : state === "success" ? (
			<Button mode="contained" icon="reload" onPress={onRecordAgain}>
				Record again
			</Button>
		) : (
			<Button mode="contained" icon="record-circle-outline" onPress={onRecord}>
				Record
			</Button>
		);

	return (
		<Box gap={16} alignItems="center">
			<Box flexDirection="row" gap={16} justifyContent="center" flexWrap="wrap">
				{primaryButton}
				<Button
					mode="outlined"
					icon={isPlaying ? "pause" : "play"}
					onPress={onPlayback}
					disabled={!onPlayback}
				>
					Playback
				</Button>
			</Box>

			{state === "success" ? (
				<Box
					flexDirection="row"
					alignItems="center"
					gap={8}
					paddingHorizontal={16}
					paddingVertical={10}
					borderRadius={theme.roundness * 2}
					backgroundColor={theme.palette.success.info}
				>
					<AppIcon
						name="check-circle-outline"
						size={18}
						color={theme.palette.success.dark}
					/>
					<Text
						variant="bodyMedium"
						style={{ color: theme.palette.success.dark }}
					>
						{successMessage}
					</Text>
				</Box>
			) : null}
		</Box>
	);
};
